const config = {
  routes: {
    label: 'Cookies',
    prefix: '/cookies',
  },
}

export default config
